/** Базовые URL без завершающего слэша. Задаются в .env.development / .env.production (REACT_APP_*). */

function stripTrailingSlash(url) {
  return url.replace(/\/$/, '');
}

const devApi = 'http://localhost:5000';
const devExecutor = 'http://localhost:5001';
const devAi = 'http://localhost:5002';

export const API_BASE = stripTrailingSlash(
  process.env.REACT_APP_API_BASE || devApi
);

export const EXECUTOR_BASE = stripTrailingSlash(
  process.env.REACT_APP_EXECUTOR_BASE || devExecutor
);

export const AI_BASE = stripTrailingSlash(
  process.env.REACT_APP_AI_BASE || devAi
);
